var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.createOrg.apply(null, arguments);
      }
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.loadAccountStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.createOrgStatus
    }
  }), _c('sign-in-dialog', {
    scopedSlots: _vm._u([{
      key: "subtitle",
      fn: function () {
        return [_vm._v("Sign in to verify your email address")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }), !_vm.hideEmail ? _c('v-text-field', {
    staticClass: "mb-3",
    attrs: {
      "value": _vm.isSignedIn ? _vm.global.profile.email : null,
      "name": "Email address",
      "label": "Email address",
      "readonly": "",
      "error-messages": _vm.accountErr,
      "rules": [function (v) {
        return !!v || 'Required';
      }]
    },
    on: {
      "click": function ($event) {
        _vm.showSignIn = true;
      }
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "small": "",
            "loading": _vm.loadAccountStatus.pending
          },
          domProps: {
            "textContent": _vm._s(_vm.isSignedIn ? 'Change…' : 'Sign in…')
          },
          on: {
            "click": function ($event) {
              _vm.showSignIn = true;
            }
          }
        })];
      },
      proxy: true
    }], null, false, 3556598503)
  }) : _vm._e(), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "name": "Organization name",
      "label": "Organization name",
      "rules": [function (v) {
        return !!v || 'Required';
      }]
    },
    model: {
      value: _vm.params.org_name,
      callback: function ($$v) {
        _vm.$set(_vm.params, "org_name", $$v);
      },
      expression: "params.org_name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "name": "Name",
      "label": "Your name",
      "rules": [function (v) {
        return !!v || 'Required';
      }]
    },
    model: {
      value: _vm.params.customer_name,
      callback: function ($$v) {
        _vm.$set(_vm.params, "customer_name", $$v);
      },
      expression: "params.customer_name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mt-6 title",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.87)"
    }
  }, [_vm._v("What do you want to use Ellacard to do?")]), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("We'll send you tutorials / examples related to your selection(s)")]), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Send internally to your organization's employees",
      "value": "INTERNAL",
      "rules": [function (v) {
        return !!_vm.params.use_cases.length;
      }]
    },
    model: {
      value: _vm.params.use_cases,
      callback: function ($$v) {
        _vm.$set(_vm.params, "use_cases", $$v);
      },
      expression: "params.use_cases"
    }
  }), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Send outside of your organization",
      "value": "EXTERNAL",
      "rules": [function (v) {
        return !!_vm.params.use_cases.length;
      }]
    },
    model: {
      value: _vm.params.use_cases,
      callback: function ($$v) {
        _vm.$set(_vm.params, "use_cases", $$v);
      },
      expression: "params.use_cases"
    }
  }), _c('div', {
    staticClass: "text--label-active pl-8"
  }, [_vm._v("e.g. to clients / donors")]), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Add custom logo / branding",
      "value": "BRANDING",
      "rules": [function (v) {
        return !!_vm.params.use_cases.length;
      }]
    },
    model: {
      value: _vm.params.use_cases,
      callback: function ($$v) {
        _vm.$set(_vm.params, "use_cases", $$v);
      },
      expression: "params.use_cases"
    }
  }), _c('div', {
    staticClass: "text--label-active pl-8"
  }, [_vm._v("Set a custom sender email address")]), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Automate cards / group cards",
      "value": "AUTOMATION",
      "rules": [function (v) {
        return !!_vm.params.use_cases.length;
      }]
    },
    model: {
      value: _vm.params.use_cases,
      callback: function ($$v) {
        _vm.$set(_vm.params, "use_cases", $$v);
      },
      expression: "params.use_cases"
    }
  }), _c('div', {
    staticClass: "text--label-active pl-8"
  }, [_vm._v("e.g. for client birthdays or employee work anniversaries")]), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Send gift cards",
      "value": "GIFT_CARDS",
      "rules": [function (v) {
        return !!_vm.params.use_cases.length;
      }]
    },
    model: {
      value: _vm.params.use_cases,
      callback: function ($$v) {
        _vm.$set(_vm.params, "use_cases", $$v);
      },
      expression: "params.use_cases"
    }
  }), _c('div', {
    staticClass: "text--label-active pl-8"
  }, [_vm._v("e.g. Amazon, Starbucks, Uber, Visa…")]), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Share access with other members of my organization",
      "value": "SHARED_ACCESS",
      "rules": [function (v) {
        return !!_vm.params.use_cases.length;
      }]
    },
    model: {
      value: _vm.params.use_cases,
      callback: function ($$v) {
        _vm.$set(_vm.params, "use_cases", $$v);
      },
      expression: "params.use_cases"
    }
  }), _c('div', {
    staticClass: "text--label-active pl-8"
  }, [_vm._v("With detailed usage metrics and administrative oversight")]), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Other…",
      "value": "OTHER",
      "rules": [function (v) {
        return !!_vm.params.use_cases.length;
      }]
    },
    model: {
      value: _vm.params.use_cases,
      callback: function ($$v) {
        _vm.$set(_vm.params, "use_cases", $$v);
      },
      expression: "params.use_cases"
    }
  }), _c('v-expand-transition', [_c('v-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.params.use_cases.includes('OTHER'),
      expression: "params.use_cases.includes('OTHER')"
    }],
    staticClass: "mt-1 pl-8",
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "auto-grow": "",
      "rows": "2",
      "rules": [function (v) {
        return !_vm.params.use_cases.includes('OTHER') || !!v;
      }]
    },
    model: {
      value: _vm.params.notes,
      callback: function ($$v) {
        _vm.$set(_vm.params, "notes", $$v);
      },
      expression: "params.notes"
    }
  })], 1)], 1)], 1), !_vm.hideBtns ? _c('div', {
    staticClass: "mt-6 d-flex"
  }, [_c('v-spacer'), !_vm.hideCancel ? _c('v-btn', {
    staticClass: "mr-4",
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "Submit",
      "disabled": _vm.isDisabled,
      "loading": _vm.createOrgStatus.pending
    }
  }, [_vm._v(" Submit ")])], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }